// Shared across /explore tabs, header menu and mobile nav so every "category" label
// in the app follows the same rule: PROMOTION keeps a translated (multi-language)
// label; everything else follows the API — `category_name` returned by
// POST /blog/category (raw display name the author typed, e.g. "Ẩm thực"),
// falling back to a formatted code only when `category_name` is null.
export const getCategoryLabel = (
  category: string,
  t: (key: string) => string,
  nameMap: Record<string, string | null> = {}
) => {
  if (category === 'PROMOTION') return t("common.promotion")

  return nameMap[category] || category
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
